// A single captured-screenshot thumbnail: a lazy <img> linking to the full
// capture in a new tab, with a mono caption underneath. Used by the job detail
// view in three places (planned-dashboard grids, the "all screenshots" roll-up,
// and the flat pre-plan grid), so the markup lives here once.

import { gwbkAutogenShotUrl, type GwbkAutogenShot } from '@axilon-apps/domains-ontology-ui-state'

export interface GwbkAutogenShotThumbProps {
  jobId: string
  shot: GwbkAutogenShot
  /** Caption under the thumbnail. Defaults to the route key. */
  caption?: string
  /** Tailwind height class for the image (cards use `h-20`, the flat grid `h-24`). */
  imgHeightClass?: string
  /** Extra classes on the wrapper anchor (e.g. padding). */
  className?: string
}

const GwbkAutogenShotThumb = ({
  jobId,
  shot,
  caption,
  imgHeightClass = 'h-20',
  className = 'p-1'
}: GwbkAutogenShotThumbProps) => {
  const url = gwbkAutogenShotUrl(jobId, shot.name)
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className={`flex flex-col gap-1 overflow-hidden rounded border border-line bg-bg-sunk/40 ${className}`}
      title={`${shot.routeKey}${shot.variant === 'page' ? '' : ` · ${shot.variant}`}`}
    >
      <img
        src={url}
        alt={shot.routeKey}
        loading="lazy"
        className={`${imgHeightClass} w-full rounded-sm border border-line/60 bg-white object-cover object-top`}
      />
      <span className="truncate font-mono text-10 text-ink-3">{caption ?? shot.routeKey}</span>
    </a>
  )
}

export default GwbkAutogenShotThumb
